import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useTaskCategorys, TaskCategory } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<TaskCategory>
      useData={useTaskCategorys}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
